import $ from 'jquery'
import postContentSize from './content_size'

$("#story_card_story_1, #story_card_story_2, #story_card_story_3, #story_card_story_4, #story_card_story_5, #story_card_story_6").on("change keyup paste", function(){
  
  var fields = {};
  for(let i = 1; i <= 6; i++) {
    fields["story_card_story_"+i] = $("#story_card_story_"+i).val()
  }
  postContentSize("stories", "/content_size/stories", { stories: fields })
  .done(function( data ) {
    for(let i = 1; i <= 6; i++) {
      $("#story_card_"+i+"_error").hide()
    }
    if(!data["valid"]) {
      data["errors"].forEach(function(error) {
        for(let i = 1; i <= 6; i++) {
          if($("#story_card_story_"+i).val() == error){
            $("#story_card_"+i+"_error").show()
          }
        }
      });
    }
  });
});